import { Box, FormControl, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IntegrationSystemViewModel } from "../../../Types/ExportTypes";
import {
    CurrencyAutoComplete,
    LocationAutoComplete,
    ShopAutoComplete
} from "../../AutoComplete/AutoCompletes";
type ShopifyIntegrationProps = {
    viewModel: IntegrationSystemViewModel;
    setViewModel: React.Dispatch<React.SetStateAction<IntegrationSystemViewModel>>;
};


const StarwebIntegration: React.FC<ShopifyIntegrationProps> = ({ viewModel, setViewModel }) => {
    const { t } = useTranslation();
    const [starwebClientId, setStarwebClientId] = useState("");
    const [starwebSecret, setStarwebSecret] = useState("");
    const [starwebLocationCode, setStarwebLocationCode] = useState("");
    const [starwebShopNo, setStarwebShopNo] = useState("");
    useEffect(() => {
        if (viewModel.tag !== "Starweb") {
            setViewModel(prev => ({ ...prev, tag: "Starweb", integrateItems: true, inventory: true, active: true,lockOrder : true, lockSalesLines : true }));
        }
    }, [viewModel.tag, setViewModel]);


    const setSetting = (key: string, value: string) => {
        setViewModel(prev => {
            const settings = prev.settings ? [...prev.settings] : [];

            const idx = settings.findIndex(s => s.key === key);

            if (idx >= 0) {
                // update existing
                settings[idx] = { ...settings[idx], value };
            } else {
                // add new
                settings.push({
                    key,
                    value,
                    integrationId: prev.id ?? null,
                });
            }

            return { ...prev, settings };
        });
    };
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            <TextField
                fullWidth
                label={t("common.description")}
                value={viewModel.description}
                onChange={(e) => setViewModel({ ...viewModel, description: e.target.value })}
                InputLabelProps={{ shrink: true }}
            />


            <TextField
                fullWidth
                label={"Url"}
                value={viewModel.serviceUrl1}
                onChange={(e) => setViewModel({ ...viewModel, serviceUrl1: e.target.value })}
                InputLabelProps={{ shrink: true }}
            />



            <TextField
                label="Starweb Client Id"
                value={starwebClientId}
                onChange={(e) => {
                    const val = e.target.value;
                    setStarwebClientId(val);
                    setSetting("ClientId", val);
                }}
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="Starweb Client Secret"
                value={starwebSecret}
                onChange={(e) => {
                    const val = e.target.value;
                    setStarwebSecret(val);
                    setSetting("ClientSecret", val);
                }}
                InputLabelProps={{ shrink: true }}
            />

            <FormControl fullWidth margin="normal">
                <ShopAutoComplete
                    key={starwebShopNo}
                    valueId={starwebShopNo}
                    onChange={(selected) => {
                        const val = selected?.value ?? "";              
                        setViewModel({ ...viewModel, shopNo: val });
                        setStarwebShopNo(val);
                    }}

                    infoText={t("help.shopHelp")}
                />
            </FormControl>

            <FormControl fullWidth margin="normal">
                <LocationAutoComplete
                    key={starwebLocationCode}
                    valueId={starwebLocationCode}
                    onChange={(selected) => {
                        const val = selected?.value ?? "";
                        
                        setViewModel({ ...viewModel, locationCodeFilter: val });
                        setStarwebLocationCode(val);
                    }}

                    infoText={t("help.locationHelp")}
                />
            </FormControl>


        </Box>
    );
};


export default StarwebIntegration;
